import { Request } from "./Requests";
import { buildVisibilityRoles } from "../utils/VisibilityRolesUtil";
const RequestBuilder = new Request.Builder("explore", "storelist");

const service = {
    getAllStoreListsWithArticles(
        country: string,
        storeId: string,
        isEmployee: boolean,
        isLoggedIn: boolean,
        isWebCustomer: boolean,
        isFsdCustomer: boolean,
        customerSegment: string
    ) {
        const template = "/public/country/{country}/store/{storeId}";
        const pathParams = {
            country,
            storeId
        };
        const roles = buildVisibilityRoles(isEmployee, isLoggedIn, isWebCustomer, isFsdCustomer, customerSegment);

        return RequestBuilder.path(template, pathParams)
            .query({ visibilityRoles: roles })
            .get();
    }
};

export default service;
